export enum LogType {
  UNDEFINED_LOG_REFERENCE_TYPE = 0,
  EQUIPMENT_TIMEOUT = 1,
  CHALLENGE = 2,
  COIN_TOSS = 3,
  GAME_OVER = 4,
  FORFEIT = 5,
  MATCH_OVER = 6,
  MEDICAL_TIMEOUT = 7,
  MISSED_SERVE = 8,
  PENALTY = 9,
  PLAYERS_ON_COURT = 10,
  POINT_REPLAY = 11,
  POINT_IN_PROGRESS = 12,
  RETIREMENT = 13,
  POINT = 14,
  SERVE_SELECTION = 15,
  SIDE_OUT = 16,
  SWITCH_ENDS = 17,
  TIME_OUT = 18,
  TIME_VIOLATION = 19,
  WARMING_UP = 20,
  SUSPENSION = 21,
  START_SCORING = 22,
  SWITCH_SERVER = 23,
  TIME_IN = 24,
  COURT_ARRIVAL = 25,
  STATISTIC = 26,
  CHANGE_REFEREE = 27,
  CHECK_CONNECTION = 28,
  COLLECT_RALLY_STATISTIC = 29,
  WITHDRAWAL = 30,
  UNDO = 31,
  MOVE_PLAYERS = 32,
  CHANGE_SERVER = 33,
  REMOVE_PENALTY = 34,
  ADDITIONAL_TIMEOUT = 35,
  CHANGE_OF_SIDE = 36,
}
